export default __webpack_public_path__ + "static/media/para-2.23947c4e.png";